import { Col, Row, Form, Breadcrumb, Tabs, message } from "antd";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { createItems, editItems } from "../../api/itemapi";
import { useMutation } from "react-query";
import CancelBtn from "../UI/CancelButton/CancelBtn";
import { Description } from "./DescriptionAdd";
import { GeneralInformation } from "./GeneralInformation";
import { useTranslation } from "react-i18next";
import { useNavigate, useLocation } from "react-router-dom";
import { ItemsType } from "./itemsType";
import Packaging from "./AddEditPackaging/packaging";
import { Link } from "react-router-dom";
import Components from "./AddEditComponent/components";
import PreviousButton from "../UI/PreviousButton/previousbutton";
import NextButton from "../UI/NextButton/nextbutton";
import AddEditButton from "../UI/AddEditButton/addeditbutton";
import AddEditModal from "../UI/ModalComponent/AddEditModal/addeditcomponent";
import ItemModifier from "./AddEditModifier/itemmodifier";

export interface Option {
  type: string;
  typeId: number;
  id: number;
  value: string;
}
function AddEditItem() {
  const location = useLocation();
  const [, setError] = useState("");
  const [form] = Form.useForm();
  const [t] = useTranslation("common");
  const navigate = useNavigate();
  const [key, setKey] = useState(location?.state?.key || "1");
  const { id } = useParams();
  const isEdit = () => {
    return !!id;
  };
  const [editStatus] = useState(isEdit());
  const item = location?.state?.item;
  const formatedBrand = location?.state?.formatedBrand;
  const loadingBrand = location?.state?.loadingBrand;
  const formatedPriceScheme = location?.state?.formatedPriceScheme;
  const loadingPriceScheme = location?.state?.loadingPriceScheme;
  const formatedSupplier = location?.state?.formatedSupplier;
  const loadingSupplier = location?.state?.loadingSupplier;
  const formatedcategory = location?.state?.formatedcategory;
  const loadingcategory = location?.state?.loadingcategory;

  const [setCategory] = useState("");
  const [ItemName, setItemName] = useState(false);
  const [Barcode, setBarcode] = useState(false);
  const [setType] = useState("");
  const [setItemUnit] = useState("");
  const [open, setOpen] = useState(false);
  const [isComposed, setIsComposed] = useState(item?.isComposed || false);
  const [isPacking, setIsPacking] = useState(item?.isPacking || false);
  const [selectedCategory, setSelectedCategory] = useState<any>(null);
  const [selectedItemUnit, setSelectedItemUnit] = useState<any>(null);

  useEffect(() => {
    if (editStatus) {
      setItemName(true);
      setBarcode(true);
      setSelectedCategory(true);
      setSelectedItemUnit(true);
    }
  }, [editStatus]);

  const { mutateAsync: mutateCreateUpdate, isLoading: isSaving } = useMutation(
    !isEdit() ? "createItems" : "editItems",
    !isEdit()
      ? (item: ItemsType) => createItems(item)
      : (item: ItemsType) => editItems(id, item),
    {
      onSuccess: (res) => {
        navigate("/items");
        message.success("Saved successfully!");
      },
      onError: (error: any) => {
        if (setError) {
          let errorMessage = "An error occurred";
          if (
            error.response &&
            error.response.data &&
            error.response.data.errors
          ) {
            const errorData = error.response.data.errors[0];
            if (errorData && errorData.msg) {
              errorMessage = errorData.param + " " + errorData.msg;
            }
          } else if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            errorMessage = error.response.data.message;
          } else {
            errorMessage = error.message;
          }
          setError(errorMessage);
          message.error(errorMessage);
        } else {
          const errorMessage =
            error.response && error.response.data && error.response.data.message
              ? error.response.data.message
              : "An error occurred";
          message.error(errorMessage);
          message.success("Complete successfully");
        }
      },
    }
  );
  
  const [isSaveHide, setIsSaveHide] = useState(false);
  const items = [
    {
      key: "1",
      label: `${t("general-information")}`,
      children: (
        <GeneralInformation
          loadingcategory={loadingcategory}
          formatedcategory={formatedcategory}
          formatedBrand={formatedBrand}
          loadingBrand={loadingBrand}
          formatedSupplier={formatedSupplier}
          loadingSupplier={loadingSupplier}
          formatedPriceScheme={formatedPriceScheme}
          loadingPriceScheme={loadingPriceScheme}
          setCategory={setCategory}
          setItemName={setItemName}
          setBarcode={setBarcode}
          setType={setType}
          setItemUnit={setItemUnit}
          setSelectedCategory={setSelectedCategory}
          setSelectedItemUnit={setSelectedItemUnit}
          setIsSaveHide={setIsSaveHide}
          isEdit={isEdit}
          item={item}
        />
      ),
    },
    {
      key: "2",
      label: `${t("description")}`,
      children: (
        <Description
          form={form}
          item={item}
          setIsComposed={setIsComposed}
          setIsPacking={setIsPacking}
          isPacking={isPacking}
          isComposed={isComposed}
          setIsSaveHide={setIsSaveHide}
          isEdit={isEdit}
        />
      ),
      disabled: !ItemName || !selectedCategory || !selectedItemUnit,
    },
  ];
  if (isEdit()) {
    items.push({
      key: "3",
      label: `${t("components")}`,
      children: <Components />,
      disabled: !isComposed,
    });
  }
  if (isEdit()) {
    items.push({
      key: "4",
      label: `${t("packaging")}`,
      children: <Packaging category={item} />,
      disabled: !isPacking,
    });
  }
  if (isEdit()) {
    items.push({
      key: "5",
      label: `${t("modifiers")}`,
      children: <ItemModifier />,
      disabled: false,
    });
  }

  const [activeTabLabel, setActiveTabLabel] = useState(items[0].label);

  const updateActiveTabLabel = (activeKey: string) => {
    const activeItem = items.find((item) => item.key === activeKey);
    if (activeItem) {
      setActiveTabLabel(activeItem.label);
    } else if (activeKey === "4") {
      setActiveTabLabel(items[items.length - 1].label);
    } else {
      setActiveTabLabel("");
    }
  };

  const onChange = (key: string) => {
    setKey(key);
    updateActiveTabLabel(key);
  };

  const handleNext = () => {
    let currentIndex = items.findIndex((item) => item.key === key);
    let nextIndex = currentIndex + 1;

    while (nextIndex < items.length && items[nextIndex].disabled) {
      nextIndex++;
    }

    if (nextIndex < items.length) {
      const nextKey = items[nextIndex].key;
      setKey(nextKey);
      updateActiveTabLabel(nextKey);
    }
  };

  const handlePrevious = () => {
    let currentIndex = items.findIndex((item) => item.key === key);
    let previousIndex = currentIndex - 1;

    while (previousIndex >= 0 && items[previousIndex].disabled) {
      previousIndex--;
    }

    if (previousIndex >= 0) {
      const previousKey = items[previousIndex].key;
      setKey(previousKey);
      updateActiveTabLabel(previousKey);
    }
  };

  const handleFinish = () => {
    const newitems = form.getFieldsValue();
    const firstFile = newitems.image && newitems.image.fileList && newitems.image.fileList[0];
    newitems.image = firstFile ? firstFile.originFileObj : typeof newitems.image !== 'string' ? "" : newitems.image;
    for (const key in newitems) {
      if (newitems[key] === undefined) {
        if (key === "isActive" || key === "isTrackable") {
          newitems[key] = true;
        } else if (key === "minInStock") {
          newitems[key] = 1;
        } else if (
          key === "isPacking" ||
          key === "isComposed" ||
          key === "isTaxable"
        ) {
          newitems[key] = false;
        } else {
          newitems[key] = null;
        }
      } else if (key === "isPacking" || key === "isComposed") {
        newitems[key] = newitems[key] || false;
      } else if (key === "isTrackable") {
        newitems[key] = newitems[key] || true;  
      } else if (key === "isTaxable") {
        newitems[key] = newitems[key] || false;               
      } else if (
        typeof newitems[key] === "string" &&
        newitems[key].trim() === ""
      ) {
        newitems[key] = null;
      }
    }
    mutateCreateUpdate(newitems);
  };

  return (
    <>
      <Row>
        <Col offset={1} span={20} style={{ marginBottom: "10px" }}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("inventory")}</>,
              },
              {
                title: <Link to="/items">{t("items-list")}</Link>,
              },
              {
                title: (
                  <>{isEdit() ? `${t("edit-item")}` : `${t("add-item")}`}</>
                ),
              },
              {
                title: (
                  <span className="breadcrumbcolor">{activeTabLabel}</span>
                ),
              },
            ]}
          />
        </Col>

        {/* {isEdit() ? (
          <Col className="editTitle" offset={1} span={20}>
            {item?.name}
          </Col>
        ) : (
          <Col className="editTitle" offset={1} span={20}>
            {t("add-item")}
          </Col>
        )} */}
        <Row style={{ minHeight: "69vh" }}>
          <Col offset={1} span={22}>
            <Form
              layout="vertical"
              style={{ margin: "auto" }}
              form={form}
              id="itemsform"
              onFinish={handleFinish}
              initialValues={{
                categoryId: item?.category?.id,
                typeId: item?.type?.id,
                unitId: item?.unit?.id,
                supplierId: item?.supplier?.id,
                priceSchemeId: item?.price?.id,
                brandId: item?.brand?.id,
                width: item?.width,
                height: item?.height,
                depth: item?.depth,
                minInStock: item?.minInStock,
                isComposed: item?.isComposed,
                listOrder: item?.listOrder,
                weight: item?.weight,
                isPacking: item?.isPacking,
                unitValue: item?.unitValue,
                sku: item?.sku,
                name: item?.name,
                barcode: item?.barcode,
                description: item?.description,
                color: item?.color || "#ffffff",
                isTrackable: isEdit() ? item?.isTrackable : true,
                isActive: isEdit() ? item?.isActive : true,
                isTaxable: item?.isTaxable,
                image: item?.image || ""
              }}
            >
              <Tabs
                data-testid="tabs-test"
                className="ant-tab"
                defaultActiveKey="1"
                activeKey={key}
                items={items}
                onChange={onChange}
              />
            </Form>
          </Col>
        </Row>
        <Col offset={1} span={4}>
          <CancelBtn data-testid="cancel-button" />
        </Col>

        <Col
          offset={16}
          span={2}
          style={{ display: "flex", justifyContent: "flex-end", gap: "20px" }}
        >
          <Col
            style={{
              display: "flex",
              justifyContent: "flex-end",
            }}
          >
            {" "}
            <PreviousButton
              onClick={() => handlePrevious()}
              disabled={key === "1"}
              data-testid="previous-button"
            />
          </Col>

          {key !== items.length.toString() ? (
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <NextButton
                disabled={!ItemName || !selectedCategory || !selectedItemUnit}
                onClick={() => handleNext()}
              />
            </Col>
          ) : (
            <Col
              style={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              {isSaveHide ? (
                <AddEditButton
                  disabled={""}
                  onClick={() => {
                    setOpen(true);
                  }}
                  isLoading={""}
                />
              ) : (
                <></>
              )}
            </Col>
          )}
        </Col>
      </Row>

      <AddEditModal
        form="itemsform"
        open={open}
        setOpen={setOpen}
        name={<span> {item?.name}</span>}
        title={`${t("item")}`}
        isSaving={isSaving}
      />
    </>
  );
}

export default AddEditItem;
